module.exports = __webpack_public_path__ + "img/activity-receive.7d3349b4.png";